module.exports = __webpack_public_path__ + "img/couples_07_V.c1a98e89.webp";